import AhaButton from '@mindthegapstudio/stpancras-storybook-app/src/components/UI/Button.vue'
// package
import { version } from '@mindthegapstudio/stpancras-storybook-app/package.json'

const install = (Vue) => {
  Vue.component('AhaButton', AhaButton)
}

export default {
  install,
  version,
}
